export class JobProgressStepIdentityRestorationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entitiesTotal",
            "baseName": "entitiesTotal",
            "type": "number",
            "format": ""
        },
        {
            "name": "entitiesRestoredFromRecycleBin",
            "baseName": "entitiesRestoredFromRecycleBin",
            "type": "number",
            "format": ""
        },
        {
            "name": "entitiesRecreated",
            "baseName": "entitiesRecreated",
            "type": "number",
            "format": ""
        },
        {
            "name": "entitiesSkippedExisting",
            "baseName": "entitiesSkippedExisting",
            "type": "number",
            "format": ""
        },
        {
            "name": "entitiesFailed",
            "baseName": "entitiesFailed",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepIdentityRestorationData.attributeTypeMap;
    }
    constructor() {
    }
}
